import { render, staticRenderFns } from "./IAGPolicyInfo.vue?vue&type=template&id=32721343"
import script from "./IAGPolicyInfo.vue?vue&type=script&lang=js"
export * from "./IAGPolicyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports